/**
 * ProLockedCard — shown in place of a Pro-only data section when the user
 * doesn't have Pro/Elite access. Keeps the UI honest (user sees the section
 * exists) while making the upgrade path obvious.
 */
import { Link } from 'react-router-dom';
import { Lock, Crown, ArrowRight } from 'lucide-react';
import { trackTierGate } from '../lib/tierGateTracker';

const ProLockedCard = ({
  title = 'Pro members only',
  description = 'Upgrade to Pro to unlock detailed lake intel — named fish, lake records, depth, stock level and more.',
  testId = 'pro-locked-card',
  surface = 'lake_pro_card',
  feature = 'lake_detail.pro_intel',
  requiredTier = 'pro',
  metadata = null,
}) => {
  return (
    <div
      data-testid={testId}
      className="glass-card relative overflow-hidden p-6"
    >
      {/* Gold radial accent */}
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#c8b273]/10 blur-3xl"
      />
      <div className="relative flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#c8b273]/30 bg-[#c8b273]/10">
            <Lock className="h-5 w-5 text-[#c8b273]" />
          </div>
          <div>
            <p className="data-label mb-1 text-[#c8b273]">Pro Intel</p>
            <h3 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-wider text-white">
              {title}
            </h3>
            <p className="mt-1 max-w-md text-sm text-[#8a948a]">{description}</p>
          </div>
        </div>
        <Link
          to="/subscription"
          data-testid={`${testId}-cta`}
          onClick={() => trackTierGate({ surface, feature, requiredTier, metadata })}
          className="inline-flex items-center gap-2 self-start rounded bg-[#c8b273] px-4 py-2 text-sm font-bold uppercase tracking-wide text-[#0b0d0b] transition-colors hover:bg-[#d8c283] sm:self-auto"
        >
          <Crown className="h-4 w-4" />
          Upgrade
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default ProLockedCard;
